export type Volume = {
  number: string
  title: string
  subtitle: string
  popular?: boolean
  problem: string
  bullets: string[]
  result: string
}

export const volumes: Volume[] = [
  {
    number: 'Volume 1',
    title: 'Hybrid Racing Foundations & Coaching System',
    subtitle:
      'The foundation your athletes need to feel safe, supported and prepared from day one',
    popular: true,
    problem:
      'Coaching complete beginners is the most rewarding — and most demanding — part of hybrid racing. This volume gives you 25 sessions that build the base with clarity and structure, without improvising a single cue.',
    bullets: [
      'How to introduce fundamental movement patterns — running, transitions and positioning from the first session',
      'How to teach positioning and body awareness — balance, weight distribution, hip control, base positioning and support points',
      'How to sequence safety instructions — touch protocol, track etiquette, communication during controlled training and injury prevention',
      'How to teach efficient pacing — pacing strategy, effort management and consistency over distance',
      'How to introduce functional positioning and control — starting position, breathing patterns and structural positioning',
    ],
    result:
      'Your beginners feel supported, capable and motivated to return — from their first session.',
  },
  {
    number: 'Volume 2',
    title: 'Running Under Fatigue & Race Conditioning',
    subtitle: 'Structured, progressive and ready to teach at every step',
    problem:
      'Running under fatigue is the single hardest quality to coach consistently week after week. This volume gives you 25 fully structured sessions so every workout feels intentional and progressive.',
    bullets: [
      'How to develop running under fatigue progressions',
      'How to teach pacing strategy development',
      'How to build aerobic base development',
      'How to work threshold and interval training',
      'How to teach breathing control techniques',
      'How to improve station-to-run transitions',
    ],
    result:
      'You coach running under fatigue with confidence and consistency — and your athletes feel clear, measurable progress every week.',
  },
  {
    number: 'Volume 3',
    title: 'Sled, Carries & Functional Strength',
    subtitle:
      'Technical with intention — fully guided from the first exercise to the last progression',
    problem:
      'Sleds, carries and loaded work demand precise cues and smooth progressions. This volume removes all planning pressure and gives you sessions that flow from setup to full execution.',
    bullets: [
      'How to teach sled push and pull mechanics',
      'How to develop loaded carry progressions',
      'How to build lunge conditioning',
      'How to develop grip endurance',
      'How to teach strength under fatigue',
      'How to use equipment alternatives',
    ],
    result:
      'Your athletes develop the strength and muscular endurance hybrid racing requires — without sacrificing technique.',
  },
  {
    number: 'Volume 4',
    title: 'SkiErg, Rowing & Engine Development',
    subtitle: 'Machine technique and cardiovascular output, coached together',
    problem:
      'Machines can consume massive amounts of energy when used inefficiently. This volume teaches coaches how to develop both machine technique and aerobic output at the same time.',
    bullets: [
      'How to teach SkiErg mechanics and pacing',
      'How to teach rowing stroke sequencing',
      'How to develop aerobic power',
      'How to structure threshold interval work',
      'How to optimize machine efficiency',
      'How to maintain repeatable output',
    ],
    result:
      'Your athletes improve machine efficiency and hold repeatable output throughout a full race.',
  },
  {
    number: 'Volume 5',
    title: 'Wall Balls, Burpees & High-Fatigue Stations',
    subtitle: 'Movement efficiency when the repetition count stops being kind',
    problem:
      'High-repetition movements become significantly harder when athletes are already fatigued. This volume focuses on holding movement efficiency as repetition count and cardiovascular demand climb.',
    bullets: [
      'How to teach wall ball mechanics and pacing',
      'How to teach burpee efficiency under fatigue',
      'How to develop repetition strategy',
      'How to build muscular endurance progressions',
      'How to maintain technique under high volume',
      'How to teach high-volume conditioning',
    ],
    result:
      'Your athletes improve high-repetition station efficiency exactly when they are under serious fatigue.',
  },
  {
    number: 'Volume 6',
    title: 'Race Simulation, Strategy & Performance',
    subtitle:
      'Where every previous quality becomes complete competition execution',
    problem:
      'Volume 6 combines the previous components into race preparation. It helps coaches move athletes from individual training qualities toward full competition execution.',
    bullets: [
      'How to structure partial and full race simulations',
      'How to build progressive race-specific training',
      'How to develop athlete-specific pacing plans',
      'How to improve transition efficiency',
      'How to create athlete-specific strategy',
      'How to organize race-week preparation',
    ],
    result:
      'Your athletes transform from physically prepared to competition-ready.',
  },
]
